import { Stepper } from '@mantine/core';
import { useContext } from 'react';
import { UserContext } from '../../../contexts';
import { HealthCheckSuccess } from './healthcheck-view';
import styles from './views.module.css';

export function SuccessView() {
  const { user } = useContext(UserContext);

  if (!user?.has_active_subscription) {
    return <HealthCheckSuccess />;
  } else {
    return (
      <div id={styles.viewContainer}>
        <p>Your integration has been started! You will receive an email once the integration is complete.</p>
        <p>You can close this tab now</p>
        <div id={styles.successStepperContainer}>
          <Stepper
            active={3}
            orientation="vertical"
            size="lg"
            styles={{ verticalSeparator: { display: 'none' } }}
            color="violet.5"
          >
            <Stepper.Step label="We've got it from here!" />
            <Stepper.Step
              label="Bloomfilter will send you an email when your data is ready"
              description="Integrations can take between 1–8 hours depending on your instance. Click on the link within the email to be directed to your Bloomfilter dashboard."
            />
            <Stepper.Step label="Take a coffee break!" />
          </Stepper>
        </div>
      </div>
    );
  }
}
